/**
 * Shop-the-look cards: selected state, variant price, ATC label.
 * Extra items are added from product-form.js.
 */
(function () {
  if (window.__shopTheLookInit) return;
  window.__shopTheLookInit = true;

  function updateCardSelectedState(card) {
    var checkbox = card.querySelector('[data-shop-the-look-checkbox]');
    card.classList.toggle('is-selected', Boolean(checkbox && checkbox.checked));
  }

  function updateAddToCartButton(container) {
    if (!container) return;

    var product = container.closest('.product');
    var button = product && product.querySelector('.product-form__submit');
    if (!button) return;

    var labelSpan = button.querySelector('span');
    if (!labelSpan || labelSpan.classList.contains('sold-out-message')) return;

    if (!button.dataset.shopTheLookDefaultLabel) {
      button.dataset.shopTheLookDefaultLabel = labelSpan.textContent.trim();
    }

    var checkedCount = container.querySelectorAll('[data-shop-the-look-checkbox]:checked').length;
    var productsLabelTemplate = container.getAttribute('data-add-products-label');

    if (checkedCount === 0 || !productsLabelTemplate) {
      labelSpan.textContent = button.dataset.shopTheLookDefaultLabel;
      button.removeAttribute('aria-label');
      return;
    }

    var productsLabel = productsLabelTemplate.replace(/__COUNT__|\{\{\s*count\s*\}\}/g, String(1 + checkedCount));
    labelSpan.textContent = productsLabel;
    button.setAttribute('aria-label', productsLabel);
  }

  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest('[data-shop-the-look-checkbox]');
    if (checkbox) {
      var card = checkbox.closest('[data-shop-the-look-item]');
      var container = checkbox.closest('[data-shop-the-look]');
      if (card) updateCardSelectedState(card);
      updateAddToCartButton(container);
      return;
    }

    var variantSelect = event.target.closest('[data-shop-the-look-variant]');
    if (!variantSelect || variantSelect.tagName !== 'SELECT') return;

    var card = variantSelect.closest('[data-shop-the-look-item]');
    var priceEl = card && card.querySelector('[data-shop-the-look-price]');
    var option = variantSelect.selectedOptions[0];
    if (priceEl && option && option.dataset.priceFormatted) {
      priceEl.textContent = option.dataset.priceFormatted;
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-shop-the-look-item]').forEach(updateCardSelectedState);
    document.querySelectorAll('[data-shop-the-look]').forEach(updateAddToCartButton);
  });
})();
